export function getPdfCss(localization: string) {
  const isLatin = localization !== `zh`;
  const HanSansSC = `HanSansSC`;
  const paragraphHeadingFont = isLatin ? `LatoBold` : HanSansSC;
  const neoSansPro = `NeoSansPro`;

  return {
    page: {
      flexDirection: `column`,
      fontFamily: isLatin ? `Lato` : HanSansSC,
      padding: `10px`,
    },

    header: {
      backgroundColor: `#E2001A`,
      height: `80px`,
      fontSize: 32,
      color: `#ffffff`,
    },

    headerText: {
      marginLeft: `24px`,
      marginTop: `24px`,
      height: `48px`,
      fontWeight: `extrabold`,
      fontFamily: isLatin ? `Lato` : HanSansSC,
    },

    brandLogoImg: {
      width: `90px`,
      maxHeight: `60px`,
    },

    brandBorder: {
      borderStyle: `solid`,
      borderTop: `10px`,
      borderBottom: `5px`,
      borderLeft: `2px`,
      borderRight: `2px`,
    },

    pdfTitleRow: {
      flexDirection: `row`,
      justifyContent: `center`,
      alignItems: `center`,
      margin: `0 auto`,
      width: `100%`,
      color: `#E2001A`,
      fontSize: 20,
      marginBottom: 10,
      fontFamily: isLatin ? neoSansPro : HanSansSC,
      fontWeight: 900,
    },

    pdfTitleCol: {
      flex: `1 0 0`,
      justifyContent: `center`,
      alignItems: `center`,
    },

    pdfTitleLogo: { width: `90px` },

    neoSansHeading: {
      fontFamily: neoSansPro ? `NeoSansPro` : HanSansSC,
      fontWeight: 900,
    },

    courseHeader: {
      marginLeft: `20px`,
      marginRight: `20px`,
      fontWeight: 800,
      fontSize: `24px`,
    },

    coursesubHeader: {
      left: `20px`,
      fontWeight: 800,
      fontSize: `16px`,
    },

    bold: {
      fontWeight: 800,
      fontSize: `16px`,
    },

    pdfFooterRow: {
      width: `100%`,
      flexDirection: `row`,
      justifyContent: `space-between`,
      color: `#E2001A`,
      position: `relative`,
      left: 0,
      right: 0,
      borderTopColor: `#333333`,
      borderTop: '1px',
      textAlign: `right`,
    },

    tableRow: {
      flexDirection: `row`,
      margin: `auto`,
      width: `100%`,
      borderRight: 0,
      fontSize: 13,
    },

    rowHeading: {
      fontWeight: 700,
      fontFamily: isLatin ? `NeoSansPro` : HanSansSC,
      color: `#FFFFFF`,
      backgroundColor: `#E2001A`,
      display: `flex`,
    },

    rankingHeader: {
      fontWeight: 700,
      fontFamily: isLatin ? `NeoSansPro` : HanSansSC,
      fontSize: 11,
      borderBottom: 0,
      borderTop: 0,
    },

    rankingSubHeader: {
      backgroundColor: `#F3F3F3`,
    },

    tableCol: {
      display: `flex`,
      padding: 5,
      fontFamily: isLatin ? `Lato` : HanSansSC,
      position: `relative`,
    },

    courseDetailsHeader: {
      backgroundColor: `#333333`,
      height: `62px`,
    },

    courseDetailHeadText: {
      color: `#FFFFFF`,
      display: `flex`,
      fontSize: `20px`,
      fontWeight: 800,
      position: `relative`,
      marginLeft: `20px`,
      marginTop: `20px`,
    },

    colHeading: {
      display: `flex`,
      flexDirection: `row`,
      alignItems: `center`,
    },

    tableTopCell: {
      justifyContent: `flex-start`,
      alignItems: `center`,
      paddingTop: 10,
    },

    tableCell: {
      fontSize: 10,
      lineHeight: 1.2,
    },

    tableCellHeaderLeft: {
      textAlign: `left`,
      width: `100%`,
    },

    tableCellHeaderRight: {
      textAlign: `right`,
      width: `100%`,
    },

    paragraphHeading: {
      fontWeight: `bold`,
      fontSize: `16px`,
      lineHeight: 1.5,
      marginLeft: `20px`,
      fontFamily: paragraphHeadingFont,
    },

    paragraphDateHeading: {
      fontWeight: `bold`,
      fontSize: `16px`,
      lineHeight: 1.5,
      fontFamily: paragraphHeadingFont,
      marginBottom: '16px',
    },
    paragraphDate: {
      fontSize: `16px`,
      lineHeight: 1.5,
      marginBottom: `16px`,
      fontFamily: isLatin ? `Lato` : HanSansSC,
    },
    paragraph: {
      fontSize: `16px`,
      lineHeight: 1.5,
      marginTop: `20px`,
      marginBottom: `10px`,
      fontFamily: isLatin ? `Lato` : HanSansSC,
    },

    paragraphWithLeft: {
      fontSize: `16px`,
      lineHeight: 1.5,
      fontFamily: isLatin ? `Lato` : HanSansSC,
      marginLeft: `20px`,
      marginBottom: `10px`,
    },

    courseSubHead: {
      marginTop: `20px`,
      marginBottom: `10px`,
      fontFamily: paragraphHeadingFont,
    },

    creditHeader: {
      marginBottom: `16px`,
    },

    courseTermHeader: {
      marginBottom: `20px`,
      marginTop: `10px`,
    },

    courseDetail: {
      marginLeft: `20px`,
      marginTop: `10px`,
      marginBottom: `30px`,
      marginRight: `10px`,
      fontFamily: paragraphHeadingFont,
    },

    programCell: {
      marginTop: `5px`,
      marginBottom: `5px`,
      fontSize: 10,
    },

    rowAdditionalHeading: {
      marginLeft: `16px`,
      fontFamily: isLatin ? `Lato` : HanSansSC,
      fontSize: 8,
      marginTop: `1px`,
    },

    tableRowMargin10: {
      marginTop: `10px`,
    },

    marginbottom20: {
      marginBottom: `20px`,
    },

    dateColumn: {
      width: `33.33%`,
      display: `flex`,
    },

    footerdate: {
      width: `100%`,
      marginTop: '24px',
      marginBottom: '24px',
      textAlign: `right`,
      color: `#757575`,
      left: `10%`,
      marginRight: `5px`,
      fontSize: '16px',
    },

    subTitleGray: {
      color: `#757575`,
    },

    feesCoulumn: {
      width: `70%`,
      display: `flex`,
    },

    feesSecondCoulumn: {
      width: `30%`,
      display: `flex`,
    },
    creditNumber: {
      width: `25%`,
      display: `flex`,
    },

    classTitle: {
      paddingLeft: '16px',
      paddingRight: '16px',
      width: `48%`,
      display: `flex`,
      fontFamily: isLatin ? `Lato` : HanSansSC,
    },

    divider: {
      backgroundColor: `#CCCCCC`,
      height: `1px`,
      marginTop: `10px`,
      marginBottom: `10px`,
    },

    pageDivider: {
      backgroundColor: `#333333`,
      height: `1px`,
      marginBottom: `10px`,
    },

    into: {
      color: 'DF2020',
    },
  } as const;
}

export type CoursePDFStyles = ReturnType<typeof getPdfCss>;
